<template>
  <RevButton
    class="md:hidden"
    full-width="always"
    variant="primary"
    @click="handleClick"
  >
    {{ i18n(translations.shareButtonLabel) }}
  </RevButton>
</template>

<script lang="ts" setup>
import type { MonetaryAmount } from '@backmarket/http-api'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useLogger } from '@backmarket/nuxt-module-logger/useLogger'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import { RevButton } from '@ds/components/Button'

import { LOG_ERROR_MESSAGE } from '../ReferAFriend.constants'
import translations from '../ReferAFriend.translations'
import { REFER_FRIEND_TRACKING } from '../tracking.constants'

const props = defineProps<{ referralCode: string; amount: MonetaryAmount }>()

const { trackClick } = useTracking()

const logger = useLogger()
const i18n = useI18n()

const handleClick = async () => {
  try {
    const shareText = [
      i18n(translations.shareButtonTextStart, {
        amount: i18n.price(props.amount),
      }),
      props.referralCode,
      i18n(translations.shareButtonTextEnd),
    ].join(' ')

    await navigator.share({
      title: i18n(translations.shareButtonTitle),
      text: shareText,
    })

    trackClick({
      page: REFER_FRIEND_TRACKING.PAGE,
      name: 'share_link',
      zone: 'has_refer_code',
    })
  } catch (err) {
    const error = err as Error

    logger.error(LOG_ERROR_MESSAGE.SHARE_CODE, {
      error,
      feature: 'refer-a-friend',
      refer_friend_action: 'share_code',
      owners: ['bot-squad-lifecycle-front'],
    })
  }
}
</script>
